<template>
  <button
    v-if="label"
    ref="tag"
    :class="[attrs.class, {selected: selected === label}]"
    @click="updateParent">
    <span class="tagLabel">{{ label }}<span v-if="showCancel" class="cancel"> ✕ </span></span>
  </button>
</template>

<script setup>
import {ref, computed, useAttrs} from "vue";

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line

const props = defineProps({
  label: {type: String, default: ""},
  selected: {type: String, default: ""},
  hideCrossSymbol: Boolean // false by default
});

const emit = defineEmits(["update"]);

const attrs = useAttrs();

const tag = ref(null);

const showCancel = computed(() => {
  if (props.hideCrossSymbol) return false;
  return props.selected === props.label;
});

function updateParent(clickEvent) {
  let response = "";
  if (props.selected && props.selected === props.label) {
    tag.value.blur();
  } else {
    response = props.label;
  }
  log(`updateParent: label = ${props.label}, response = ${response}`);
  emit("update", response, clickEvent);
}
</script>

<style scoped>
button {
  display: inline-flex;
  padding: 0.2em 0.4em;
  margin-top: 0.25em;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  line-height: 10px;
  /* the font's glyphs sit high in the line box (seen in Brave on macOS): the text 0.5px down */
  padding-top: 0.25em;
  padding-bottom: 0.15em;
  /* unchosen: the filter controls' dark on light grey (global.css --filter-control-*), as
     /Videos' tags were styled first (Seán, 2026-11-03: one look for every tag); chosen, green */
  border: 1px solid var(--filter-control-border);
  color: var(--filter-control-text);
  font-weight: 600; /* reads at this small size */
  background: var(--filter-control-background);
  border-radius: 0.35em;
  text-shadow: none;
  box-shadow: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

button:not(.selected):hover {
  filter: brightness(0.94);
}

a:hover:not(:focus) {
  color: #a7a7a7;
}

button.selected {
  color: white;
  opacity: 1;
  background-color: var(--brand-color);
  border-color: var(--brand-color);
}

button:hover.selected {
  filter: brightness(120%);
}

span.cancel {
  padding-left: 0.19em;
}

.tagLabel {
  display: inline-block;
  white-space: pre-line;
  text-align: center;
  line-height: 1.05;
}
</style>
